import { I18N } from '@gravity-ui/i18n';
import { Lang, getConfig, subscribeConfigure } from '../configure';
const i18n = new I18N();
// en – default lang for editor
i18n.setLang(getConfig().lang || Lang.En);
subscribeConfigure((config) => {
    if (config.lang) {
        i18n.setLang(config.lang);
    }
});
export { i18n };
export function registerKeyset(keyset, data) {
    i18n.registerKeyset(Lang.En, keyset, data.en);
    i18n.registerKeyset(Lang.Ru, keyset, data.ru);
    return i18n.keyset(keyset);
}
